import { render, staticRenderFns } from "./LuigisAutocompleteForm.vue?vue&type=template&id=bdff63c8&"
import script from "./LuigisAutocompleteForm.vue?vue&type=script&lang=js&"
export * from "./LuigisAutocompleteForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports